/**
 * 선택된 신고 사유로 control preview 요청 본문을 구성한다.
 * @param {string} reasonKey - 현재 선택된 신고 사유 키
 * @param {Array<{id:number|string,key:string}>} reasonList - 서버에서 내려준 신고 사유 목록
 * @returns {{reasonId?: number, reportReason?: string}}
 */
function buildControlPreviewPayload(reasonKey, reasonList = []) {
  const normalizedKey = normalizeReasonKey(reasonKey);
  if (!normalizedKey) {
    return {};
  }
  const matchedReason = findReasonByKey(normalizedKey, reasonList);
  if (matchedReason && matchedReason.id != null) {
    return {
      reasonId: Number(matchedReason.id),
    };
  }
  return {
    reportReason: normalizedKey,
  };
}

/**
 * 요청을 건너뛰어야 하는지 여부를 판단한다.
 * @param {string} reasonKey - 선택된 신고 사유
 * @param {string} defaultValue - 기본 선택 값
 * @returns {boolean}
 */
function shouldSkipControlPreview(reasonKey, defaultValue) {
  const normalizedKey = normalizeReasonKey(reasonKey);
  const normalizedDefault = normalizeReasonKey(defaultValue);
  return !normalizedKey || normalizedKey === normalizedDefault;
}

/**
 * 최신 응답만 반영하기 위한 요청 ID 관리기.
 */
class ControlPreviewRequestTracker {
  constructor() {
    this._latestId = 0;
  }

  /**
   * 새 요청 ID를 발급한다.
   * @returns {number}
   */
  next() {
    this._latestId += 1;
    return this._latestId;
  }

  /**
   * 전달받은 ID가 최신 요청인지 확인한다.
   * @param {number} id
   * @returns {boolean}
   */
  isLatest(id) {
    return id === this._latestId;
  }

  /**
   * 요청 ID를 초기화한다.
   */
  reset() {
    this._latestId = 0;
  }
}

function normalizeReasonKey(value) {
  return (value || "").toString().trim();
}

function findReasonByKey(reasonKey, reasonList) {
  return reasonList.find(
    (reason) => normalizeReasonKey(reason?.key) === reasonKey
  );
}

function formatReasonLabel(baseLabel, preview, fallbackLabel = "없음") {
  const safeBaseLabel = (baseLabel || "").toString().trim();
  if (!preview) {
    return safeBaseLabel;
  }
  const previewLabel = (preview.control_label || "").toString().trim();
  const resolved = previewLabel || fallbackLabel;
  if (!safeBaseLabel) {
    return resolved;
  }
  return `${safeBaseLabel} (${resolved})`;
}

module.exports = {
  buildControlPreviewPayload,
  shouldSkipControlPreview,
  ControlPreviewRequestTracker,
  formatReasonLabel,
};
